import { Papa } from "ngx-papaparse";
import { Component } from "@angular/core";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { Listing } from "@app/data/listing";
import { ViewChild } from "@angular/core";
import { ListingService } from "@app/services/listing.service";
import { Router } from "@angular/router";
import * as _ from "underscore";
import { Page } from "@app/data/page";
import {
  ListingsTableComponent,
  INVENTORY_LIMIT,
} from "@app/components/platform/listings-table.component";
import { Location } from "@angular/common";

@Component({
  templateUrl: "./bulk-import.component.html",
})
export class BulkImportComponent {
  keywords: string = "";

  step: number = 1;
  @ViewChild("mydatatable")
  mydatatable: any;

  @ViewChild("listingsTable")
  listingsTable: ListingsTableComponent;

  fields = [
    {
      field: "image",
      title: "Image",
      keywords: ["image"],
      required: false,
      type: "string",
      index: -1,
    },
    {
      field: "title",
      title: "Title",
      keywords: ["title", "name"],
      required: true,
      type: "string",
      index: -1,
    },
    {
      field: "category",
      title: "Category",
      keywords: ["category", "collection", "type"],
      type: "string",
      index: -1,
    },
    {
      field: "sku",
      title: "SKU",
      keywords: ["sku"],
      type: "string",
      index: -1,
    },
    {
      field: "description",
      title: "Description",
      keywords: ["description", "body"],
      required: false,
      type: "string",
      index: -1,
    },
    {
      field: "barcode",
      title: "Barcode",
      keywords: ["barcode", "upc", "ean"],
      type: "string",
      index: -1,
    },
    {
      field: "price",
      title: "Price",
      keywords: ["price"],
      type: "float",
      index: -1,
    },
    {
      field: "suggested_retail_price",
      title: "MSRP",
      keywords: ["msrp"],
      type: "float",
      index: -1,
    },
    {
      field: "compare_at_price",
      title: "Compare Price",
      keywords: ["compare at"],
      type: "float",
      index: -1,
    },
    {
      field: "stock",
      title: "Stock",
      keywords: ["stock", "quantity", "qty"],
      type: "int",
      index: -1,
    },
    {
      field: "option name 1",
      title: "Option Category 1",
      keywords: ["option1 name"],
      type: "string",
      index: -1,
      isVariantField: true,
    },
    {
      field: "option value 1",
      title: "Option Value 1",
      keywords: ["option1 value"],
      type: "string",
      index: -1,
      isVariantField: true,
    },
    {
      field: "option name 2",
      title: "Option Category 2",
      keywords: ["option2 name"],
      type: "string",
      index: -1,
      isVariantField: true,
    },
    {
      field: "option value 2",
      title: "Option Value 2",
      keywords: ["option2 value"],
      type: "string",
      index: -1,
      isVariantField: true,
    },
    {
      field: "option name 3",
      title: "Option Category 3",
      keywords: ["option3 name"],
      type: "string",
      index: -1,
      isVariantField: true,
    },
    {
      field: "option value 3",
      title: "Option Value 3",
      keywords: ["option3 value"],
      type: "string",
      index: -1,
      isVariantField: true,
    },
  ];
  dropzoneConfig: DropzoneConfigInterface = {
    url: "api/v2/fakeupload",
    maxFilesize: 2,
    acceptedFiles: "text/csv",
  };
  importCsvFailed: boolean = false;
  parsingError: string;
  listingsCount: number;
  headers: string[] = [];
  data = [];
  sampleSize: number[] = [];
  listings: Listing[] = [];
  importing: boolean = false;
  parsing: boolean = false;
  processing: boolean = false;
  rows: Listing[] = [];
  listingsWithoutImages: Listing[] = [];
  page = new Page();
  importedListings: Listing[] = [];

  constructor(
    private papa: Papa,
    private listingService: ListingService,
    private router: Router,
    private location: Location
  ) {
    this.page.pageNumber = 0;
  }

  previousStep() {
    this.step--;
  }

  import() {
    this.importing = true;
    this.listingService.createBulk(this.listings).then((listings) => {
      console.log(listings);
      this.importedListings = listings;
      this.importing = false;
      this.listingsWithoutImages = _.filter(listings, (listing) => {
        return listing.images.length === 0;
      });
      if (this.listingsWithoutImages.length > 0) {
        this.step++;
        this.filter();
      } else {
        this.router.navigate(["/inventory/list"], {
          queryParamsHandling: "preserve",
        });
      }
    });
  }

  goBack() {
    this.location.back();
  }

  getValue(data: string, type: string) {
    switch (type) {
      case "float":
        if (data) {
          var num = data.replace(/[^\d\.]*/g, "").trim();
          if (num.length > 0) {
            return parseFloat(num).toFixed(2);
          }
        }
        break;
      case "int":
        if (data) {
          var num = data.replace(/[^\d\.]*/g, "").trim();
          if (num.length > 0) {
            return parseInt(num);
          }
        }
        break;
      case "string":
        if (data) {
          return data;
        }
        break;
    }
    return null;
  }

  createTitle(listing) {
    var options = [];
    for (let i = 1; i <= 3; i++) {
      let option = listing["option value " + i];
      if (option && option.length > 0) {
        options.push(option);
      }
    }
    return options.join(",");
  }

  addOption(listing, option) {
    let optionTitle = this.createTitle(option);
    if (optionTitle.length > 0) {
      listing.variations[0].options.push({
        sku: option.sku,
        title: optionTitle,
        compare_at_price: option.compare_at_price || listing.compare_at_price,
        price: option.price || listing.price,
        suggested_retail_price:
          option.suggested_retail_price || listing.suggested_retail_price,
        barcode: option.barcode,
        stock: option.stock,
      });
    }
    if (option.image && option.image.length > 0) {
      listing.images.push(option.image);
    }
  }

  filter() {
    this.rows = [];
    let filteredListings = _.filter(this.listingsWithoutImages, (listing) => {
      return (
        (listing.category && listing.category.includes(this.keywords)) ||
        (listing.title && listing.title.includes(this.keywords)) ||
        (listing.description && listing.description.includes(this.keywords)) ||
        (listing.sku && listing.sku.includes(this.keywords))
      );
    });

    this.rows = filteredListings.slice(
      this.page.pageNumber * INVENTORY_LIMIT,
      Math.min(
        this.page.pageNumber * INVENTORY_LIMIT + INVENTORY_LIMIT,
        filteredListings.length
      )
    );
    this.page.size = this.rows.length;
    this.page.totalElements = this.listingsWithoutImages.length;
    this.page.totalPages = Math.ceil(this.rows.length / INVENTORY_LIMIT);
  }

  processData() {
    this.processing = true;
    this.listings = [];
    var lastListingWithTitle;
    this.data.forEach((row) => {
      let listing = new Listing();
      this.fields.forEach((field) => {
        if (field.index > -1)
          listing[field.field] = this.getValue(row[field.index], field.type);
      });

      if (!listing.title || listing.title.length == 0) {
        //this is a variant
        if (lastListingWithTitle) {
          this.addOption(lastListingWithTitle, listing);
        }
      } else {
        //this is a main product
        lastListingWithTitle = listing;
        let options = [];
        listing.images = [];
        listing.variations = [{ id: null, title: null, options: options }];
        this.addOption(listing, listing);
        this.listings.push(listing);
      }
    });
    console.log("listings length", this.listings.length);
    this.step = 2;
    this.processing = false;
  }

  parseCSV(file) {
    console.log("in parse csv");
    this.parsing = true;
    this.papa.parse(file, {
      complete: (result) => {
        console.log("Parsed: ", result);
        let results = result.data;
        if (results.length < 2) {
          this.parsingError = "The file doesn't have enough lines";
          this.importCsvFailed = true;
        } else {
          var missingFields = [];
          this.headers = results[0];
          console.log("headers", this.headers);
          this.headers.forEach((header, index) => {
            this.fields.forEach((field) => {
              field.keywords.forEach((keyword) => {
                if (
                  header.toLowerCase().includes(keyword) &&
                  field.index === -1
                ) {
                  field.index = index;
                }
              });
            });
          });

          this.data = results.splice(1, results.length - 1);
          this.sampleSize = Array.from(
            Array(Math.min(5, this.data.length)),
            (x, i) => i
          );
        }
        this.parsing = false;
      },
    });
  }
}
